// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1ew3_","question":"Question_question__18MC7","description":"Question_description__3dlWq"};